import { useLingui } from '@lingui/react/macro';

export const useFormatDate = (dateString: string, options: Intl.DateTimeFormatOptions = {}) => {
  const { i18n } = useLingui();

  const date = new Date(dateString);
  return i18n.date(date, options);
};
